import { useQuery } from 'react-query';

import { getPeriodReportList } from 'api/periodReports/getPeriodReportList';

interface QueryOptions {
  slug: string;
  enabled?: boolean;
}

export const useGetPeriodReportList = ({ slug, enabled = true }: QueryOptions) => {
  const { data, refetch, isLoading, isFetching } = useQuery('periodReportList', () => getPeriodReportList(slug), {
    refetchOnWindowFocus: false,
    refetchInterval: 5000,
    enabled,
  });

  return { data, refetch, isLoading, isFetching };
};

export default useGetPeriodReportList;
